export function Sparkle() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.13067 9.23035L7.68 5.45901C7.65823 5.40241 7.61982 5.35375 7.56984 5.31942C7.51985 5.28509 7.46064 5.26671 7.4 5.26671C7.33936 5.26671 7.28015 5.28509 7.23016 5.31942C7.18018 5.35375 7.14177 5.40241 7.12 5.45901L5.66933 9.23035C5.65427 9.26954 5.63114 9.30512 5.60146 9.33481C5.57177 9.36449 5.53618 9.38762 5.497 9.40269L1.72567 10.8534C1.66907 10.8751 1.6204 10.9135 1.58607 10.9635C1.55175 11.0135 1.53337 11.0727 1.53337 11.1334C1.53337 11.194 1.55175 11.2532 1.58607 11.3032C1.6204 11.3532 1.66907 11.3916 1.72567 11.4134L5.497 12.864C5.53618 12.8791 5.57177 12.9022 5.60146 12.9319C5.63114 12.9616 5.65427 12.9972 5.66933 13.0364L7.12 16.8077C7.14177 16.8643 7.18018 16.913 7.23016 16.9473C7.28015 16.9816 7.33936 17 7.4 17C7.46064 17 7.51985 16.9816 7.56984 16.9473C7.61982 16.913 7.65823 16.8643 7.68 16.8077L9.13067 13.0364C9.14574 12.9972 9.16886 12.9616 9.19854 12.9319C9.22823 12.9022 9.26382 12.8791 9.303 12.864L13.0743 11.4134C13.1309 11.3916 13.1796 11.3532 13.2139 11.3032C13.2483 11.2532 13.2666 11.194 13.2666 11.1334C13.2666 11.0727 13.2483 11.0135 13.2139 10.9635C13.1796 10.9135 13.1309 10.8751 13.0743 10.8534L9.303 9.40269C9.26382 9.38762 9.22823 9.36449 9.19854 9.33481C9.16886 9.30512 9.14574 9.26954 9.13067 9.23035Z"
        stroke="#00824C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.06667 2.73334L3.4 1L2.73333 2.73334L1 3.40001L2.73333 4.06667L3.4 5.80001L4.06667 4.06667L5.8 3.40001L4.06667 2.73334Z"
        stroke="#00824C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.689 4.37767L13.8 2.06667L12.911 4.37767L10.6 5.26668L12.911 6.15568L13.8 8.46668L14.689 6.15568L17 5.26668L14.689 4.37767Z"
        stroke="#00824C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
